module.exports = __webpack_public_path__ + "static/media/Sharp-ePoster-28.5-inch--Display.c9924785.jpg";